<template>
  <div class="slide-page">
    <NavBarM @jump="jump" ref="navbar"></NavBarM>
    <!-- 热招岗位 -->
    <div class="slide-content" ref="content">
      <div>
        <div class="job-box">
          <img class="title-img" src="../../assets/img/label-post.png" alt="" />

          <div v-if="jobList.length">
            <el-collapse
              v-model="activeNames"
              @change="handleChange"
              style="width: 86vw; margin: 0 7vw"
            >
              <el-collapse-item
                title="Consistency"
                :name="index"
                v-for="(item, index) in jobList"
                :key="index"
              >
                <template #title>
                  <span style="flex: 1; text-align: left; font-size: 0.4rem">{{
                    item.name
                  }}</span>
                  <div
                    style="
                      display: inline-block;
                      margin: 0 15px;
                      font-size: 0.3rem;
                      color: #666;
                      align-self: center;
                    "
                  >
                    查看详情
                  </div>
                  <div
                    style="
                      display: inline-block;
                      background-color: rgba(35, 110, 235, 1);
                      color: #fff;
                      height: 30px;
                      line-height: 30px;
                      padding: 0 12px;
                      font-size: 0.3rem;
                      border-radius: 6px;
                      cursor: pointer;
                    "
                    @click.stop="show(index)"
                  >
                    立即申请
                  </div>
                </template>
                <template #icon></template>
                <div
                  style="
                    text-align: left;
                    padding: 0 20px;
                    line-height: 30px;
                    font-size: 0.35rem;
                  "
                >
                  <div style="display: flex">
                    <div style="flex: 1">
                      <span class="fw9">岗位类型：</span
                      >{{ item.positionsType }}
                    </div>
                    <div style="">
                      <span class="fw9">薪资：</span>{{ item.salary }}
                    </div>
                  </div>
                  <div><span class="fw9">需求专业：</span>{{ item.major }}</div>
                  <div>
                    <span class="fw9">工作地点：</span>{{ item.workPlace }}
                  </div>
                  <div class="fw9">岗位描述：</div>
                  <span style="white-space: pre-wrap">{{
                    item.positionsInfo
                  }}</span>
                  <div class="fw9">任职要求：</div>
                  <span style="white-space: pre-wrap">
                    {{ item.positionsRequirements }}
                  </span>
                  <a v-if="item.writtenExaminationUrl" class="fw9" style="color:#42a5ec" :href="item.writtenExaminationUrl" target="_blank">笔试地址</a>
                  <div>
                    <a
                       v-if="item.writtenExaminationUrl"
                      class="fw9" style="
                        display: inline-block;
                        background-color: rgba(35, 110, 235, 1);
                        color: #fff;
                        height: 30px;
                        line-height: 30px;
                        padding: 0 12px;
                        font-size: 0.3rem;
                        border-radius: 6px;
                        cursor: pointer;
                      " :href="item.writtenExaminationUrl" target="_blank">笔试地址</a>
                  </div>
                  </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div v-else>暂无职位~</div>
        </div>
      </div>
    </div>
    <FooterM></FooterM>
    <Popup v-model="isShow2" teleport="body" position="top">
      <Form @hidden="isShow2 = false"></Form>
    </Popup>
    <el-dialog
      title="投递简历"
      :visible.sync="isShow"
      width="100%"
      :close-on-click-modal="false"
      append-to-body
    >
      <Form @hidden="isShow = false" ref="jobForm"></Form>
    </el-dialog>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import NavBarM from "../../components/NavBarM.vue";
import FooterM from "../../components/FooterM.vue";
import Form from "./form.vue";
import { Popup } from "vant";
import { ElMessage } from "element-ui";
import { BASE_URL, LIST } from "../../service/api";

BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
    NavBarM,
    Form,
    Popup,
  },
  data() {
    return {
      isShow: false,
      isShow2: false,
      jobList: [],
      bScroll: null,
      activeNames: -1,
    };
  },
  methods: {
    refreshBS() {
      this.bScroll.refresh();
    },
    jump(index) {
      this.$emit("jump", index);
    },
    handleChange() {
      //dom改变了，需要refresh一下重新计算 BetterScroll
      setTimeout(() => {
        this.bScroll.refresh();
      }, 300);
    },
    show(index) {
      this.isShow = true;
      setTimeout(() => {
        this.$refs.jobForm?.updatePosition(this.jobList[index]);
      }, 100);
    },
    hidden() {
      this.isShow = false;
    },
  },
  mounted() {
    this.bScroll = new BScroll(this.$refs.content, {
      scrollY: true,
      scrollX: false,
      bounce: false,
      probeType: 3,
      click: true,
      nestedScroll: {
        groupId: "asdf",
      },
    });
    this.bScroll.on("beforeScrollStart", () => {
      this.$refs.navbar.hidden();
    });
    fetch(BASE_URL + LIST, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((rsp) => {
        rsp.json().then((data) => {
          this.jobList = data;
          this.bScroll.refresh();
        });
      })
      .catch(() => {
        ElMessage({ message: "获取数据失败", type: "warning" });
      });
  },
};
</script>

<style scoped>
/deep/ .el-collapse-item__arrow {
  display: none;
}
.slide-page {
  font-size: 11.2rem;
}
.fw9 {
  font-weight: 900;
}
/* /deep/ .el-collapse-item__wrap{
  background-color: transparent;
}
/deep/ .el-collapse-item__header{
  background-color: transparent;
} */
</style>
